import {
  LinearFilter,
  NearestFilter,
  OrthographicCamera,
  PerspectiveCamera,
  RGBAFormat,
  Scene,
  Vector2,
  WebGLRenderer,
  WebGLRenderTarget,
} from "three";
import { Context } from "../../../context";

export class LightLevelProbe {
  private camera: PerspectiveCamera | OrthographicCamera;
  private renderer: WebGLRenderer;
  private scene: Scene;

  private picker = new Vector2();

  private hWidth = 1000;

  private samplerTexture: WebGLRenderTarget;

  private onPointerMove = (event: PointerEvent) => {
    this.picker.x = event.clientX;
    this.picker.y = event.clientY;
  };

  constructor(context: Context) {
    this.camera = new OrthographicCamera(-100, 100, 100, -100, 1, 1000);

    this.camera.position.set(0, 200, -230);
    this.camera.lookAt(0, 0, -230);

    this.renderer = context.renderer;
    this.scene = context.scene;

    this.samplerTexture = new WebGLRenderTarget(1, 1, {
      minFilter: LinearFilter,
      magFilter: NearestFilter,
      format: RGBAFormat,
    });
  }

  init() {
    window.addEventListener("pointermove", this.onPointerMove);
  }

  teardown() {
    window.removeEventListener("pointermove", this.onPointerMove);
  }

  sample(): number | undefined {
    const min = -500;
    const max = 500;
    const step = 1000;

    let average = 0;
    let cnt = 0;
    for (let x = min; x <= max; x += step) {
      average += this.getLightness(this.hWidth + x, this.hWidth);
      cnt++;
    }

    for (let y = min; y <= max; y += step) {
      average += this.getLightness(this.hWidth, this.hWidth + y);
      cnt++;
    }

    average /= cnt;

    return average;
  }

  private getLightness(x: number, y: number): number {
    this.camera.setViewOffset(this.hWidth * 2, this.hWidth * 2, x, y, 1, 1);

    this.renderer.setRenderTarget(this.samplerTexture);
    // this.renderer.clear();
    this.renderer.render(this.scene, this.camera);

    const buffer = new Uint8Array(4);
    this.renderer.readRenderTargetPixels(
      this.samplerTexture,
      0,
      0,
      1,
      1,
      buffer
    );

    const rgb = [buffer[0], buffer[1], buffer[2]];

    // NB: leaving other measures here in case required in future
    const lightness =
      (Math.max.apply(null, rgb) + Math.min.apply(null, rgb)) / 2 / 255;
    // const intensity = (65536 * rgb[0] + 256 * rgb[1] + rgb[2]) / 16777216;
    // const average = ((rgb[0] + rgb[1] + rgb[2]) / 3) / 255;
    // const luminosity = ((0.21 * rgb[0]) + (0.72 * rgb[1]) + (0.07 * rgb[2])) / 255;

    // NB: required if we reuse main camera here
    // this.camera.clearViewOffset();
    this.renderer.setRenderTarget(null);

    return lightness;
  }
}
